import { render, staticRenderFns } from "./kenmF.vue?vue&type=template&id=2ac77e67&scoped=true"
import script from "./kenmF.vue?vue&type=script&lang=js"
export * from "./kenmF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac77e67",
  null
  
)

export default component.exports